// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UI Kit Toast - Figma aligned */
:root {
  --toast-bg: #3f4754; /* Muted dark-grey — less overpowering than near-black */
  --toast-text: #ffffff; /* White */
  --toast-muted: #d5d7db; /* Gray/300 */
  --toast-info: #2a71ff; /* Blue/300 */
  --toast-success: #219647; /* Green/300 */
  --toast-error: #fa3737; /* Red/150 */
  --toast-warning: #ffa500; /* Approx from design sample */
  --toast-neutral: #e9eaec; /* Gray/200 */
  --toast-radius: 8px;
  --toast-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.03),
    0px 3px 14px 2px rgba(0, 0, 0, 0.07),
    0px 5px 5px -3px rgba(0, 0, 0, 0.06);
}

/* ========================================
   Toast Base Styles
   ======================================== */
.tl-toast {
  display: flex;
  align-items: stretch;
  gap: 12px;
  position: relative;
  background: var(--toast-bg);
  color: var(--toast-text);
  border-radius: var(--toast-radius);
  box-shadow: var(--toast-shadow);
  padding: 8px 12px 8px 22px;
  min-width: 280px;
  max-width: 420px;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  line-height: 1.15;
  overflow: hidden;
  /* Base state */
  opacity: 1;
  transform: translateX(0);
}

/* ========================================
   Toast Internal Elements
   ======================================== */
.tl-toast__bar {
  position: absolute;
  left: 6px;
  top: 6px;
  bottom: 6px;
  width: 4px;
  border-radius: 2px;
}

.tl-toast__content {
  display: flex;
  gap: 8px;
  align-items: center;
}

.tl-toast__message {
  color: var(--toast-text);
  flex: 1;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.tl-toast__muted {
  color: var(--toast-muted);
  font-size: 12px;
}

.tl-toast__spacer {
  flex: 0;
}

.tl-toast__action {
  border: none;
  background: transparent;
  color: #0860e6; /* Blue/400 */
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  padding: 4px 6px;
  border-radius: 6px;
  transition: background-color 150ms ease;
}

.tl-toast__action:hover {
  background-color: rgba(8, 96, 230, 0.1);
}

.tl-toast__close {
  border: none;
  background: transparent;
  color: var(--toast-text);
  opacity: 0.9;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  padding: 4px;
  font-size: 18px;
  line-height: 1;
  transition: opacity 150ms ease, background-color 150ms ease;
}

.tl-toast__close:hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.1);
}

/* ========================================
   Variant Color Bars
   ======================================== */
.tl-toast--neutral .tl-toast__bar {
  background: var(--toast-neutral);
}

.tl-toast--info .tl-toast__bar {
  background: var(--toast-info);
}

.tl-toast--success .tl-toast__bar {
  background: var(--toast-success);
}

.tl-toast--warning .tl-toast__bar {
  background: var(--toast-warning);
}

.tl-toast--error .tl-toast__bar {
  background: var(--toast-error);
}

/* ========================================
   Animations - Smooth Slide from Left
   ======================================== */
@keyframes toast-slide-in-left {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes toast-slide-in-right {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes toast-slide-out-left {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-100%);
  }
}

/* Enter phase - fade in */
.tl-toast.enter {
  animation: toast-fade-in 220ms ease forwards;
}

/* Idle phase - maintain visible state */
.tl-toast.idle {
  opacity: 1;
  transform: translateX(0);
}

/* Exit phase - fade out */
.tl-toast.exit {
  animation: toast-fade-out 180ms ease forwards;
}

@keyframes toast-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes toast-fade-out {
  from { opacity: 1; }
  to   { opacity: 0; }
}

/* ========================================
   Toast Container
   ======================================== */
.tl-toast-container {
  position: fixed;
  top: 16px;
  right: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 9999;
  pointer-events: none;
}

.tl-toast-container > * {
  pointer-events: auto;
}

/* ════════════════════════════════════════════════════
   PILL TOAST — POS cart screen only
   Subtle inline pill that sits between the island
   and the right-side icon cluster in the navbar.
   ════════════════════════════════════════════════════ */
.tl-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 32px;
  padding: 0 12px 0 10px;
  border-radius: 999px;
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* subtle lift */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: default;
}

/* ── Variant backgrounds & text ── */
.tl-pill--success {
  background: rgba(5, 150, 105, 0.1);
  border: 1px solid rgba(5, 150, 105, 0.28);
  color: #065f46;
}
.tl-pill--error {
  background: rgba(220, 38, 38, 0.09);
  border: 1px solid rgba(220, 38, 38, 0.28);
  color: #991b1b;
}
.tl-pill--warning {
  background: rgba(217, 119, 6, 0.09);
  border: 1px solid rgba(217, 119, 6, 0.28);
  color: #92400e;
}
.tl-pill--info {
  background: rgba(42, 113, 255, 0.08);
  border: 1px solid rgba(42, 113, 255, 0.25);
  color: #1d4ed8;
}
.tl-pill--neutral {
  background: rgba(100, 116, 139, 0.08);
  border: 1px solid rgba(100, 116, 139, 0.22);
  color: #475569;
}

/* ── Inner elements ── */
.tl-pill__message {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tl-pill__close {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  padding: 0 0 0 4px;
  opacity: 0.55;
  color: inherit;
  display: inline-flex;
  align-items: center;
  transition: opacity 0.15s;
  flex-shrink: 0;
}
.tl-pill__close:hover { opacity: 1; }

/* ── Animations ── */
@keyframes pill-enter {
  from { opacity: 0; transform: translateY(-6px) scale(0.95); }
  to   { opacity: 1; transform: translateY(0)   scale(1);    }
}
@keyframes pill-exit {
  from { opacity: 1; transform: translateY(0)   scale(1);    }
  to   { opacity: 0; transform: translateY(-6px) scale(0.95); }
}

.tl-pill.enter { animation: pill-enter 0.22s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }
.tl-pill.idle  { opacity: 1; transform: translateY(0) scale(1); }
.tl-pill.exit  { animation: pill-exit  0.18s ease forwards; }

/* ── Dark mode ── */
.dark .tl-pill--success {
  background: rgba(5, 150, 105, 0.15);
  border-color: rgba(5, 150, 105, 0.32);
  color: #6ee7b7;
}
.dark .tl-pill--error {
  background: rgba(220, 38, 38, 0.14);
  border-color: rgba(220, 38, 38, 0.32);
  color: #fca5a5;
}
.dark .tl-pill--warning {
  background: rgba(217, 119, 6, 0.14);
  border-color: rgba(217, 119, 6, 0.32);
  color: #fcd34d;
}
.dark .tl-pill--info {
  background: rgba(42, 113, 255, 0.14);
  border-color: rgba(42, 113, 255, 0.3);
  color: #93c5fd;
}
.dark .tl-pill--neutral {
  background: rgba(100, 116, 139, 0.14);
  border-color: rgba(100, 116, 139, 0.28);
  color: #94a3b8;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/hooks/Toast.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,mBAAmB,EAAE,wDAAwD;EAC7E,qBAAqB,EAAE,UAAU;EACjC,sBAAsB,EAAE,aAAa;EACrC,qBAAqB,EAAE,aAAa;EACpC,wBAAwB,EAAE,cAAc;EACxC,sBAAsB,EAAE,YAAY;EACpC,wBAAwB,EAAE,8BAA8B;EACxD,wBAAwB,EAAE,aAAa;EACvC,mBAAmB;EACnB;;wCAEsC;AACxC;;AAEA;;6CAE6C;AAC7C;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,wBAAwB;EACxB,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;6CAE6C;AAC7C;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc,EAAE,aAAa;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,2DAA2D;AAC7D;;AAEA;EACE,UAAU;EACV,0CAA0C;AAC5C;;AAEA;;6CAE6C;AAC7C;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;6CAE6C;AAC7C;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA,0BAA0B;AAC1B;EACE,4CAA4C;AAC9C;;AAEA,wCAAwC;AACxC;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,6CAA6C;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;;6CAE6C;AAC7C;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;yDAIyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,kCAAkC;EAClC,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA,wBAAwB,UAAU,EAAE;;AAEpC,qBAAqB;AACrB;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,mCAAmC,KAAK;AAC7D;AACA;EACE,OAAO,UAAU,EAAE,mCAAmC,KAAK;EAC3D,OAAO,UAAU,EAAE,uCAAuC,EAAE;AAC9D;;AAEA,iBAAiB,sEAAsE,EAAE;AACzF,iBAAiB,UAAU,EAAE,iCAAiC,EAAE;AAChE,iBAAiB,yCAAyC,EAAE;;AAE5D,oBAAoB;AACpB;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB","sourcesContent":["/* UI Kit Toast - Figma aligned */\n:root {\n  --toast-bg: #3f4754; /* Muted dark-grey — less overpowering than near-black */\n  --toast-text: #ffffff; /* White */\n  --toast-muted: #d5d7db; /* Gray/300 */\n  --toast-info: #2a71ff; /* Blue/300 */\n  --toast-success: #219647; /* Green/300 */\n  --toast-error: #fa3737; /* Red/150 */\n  --toast-warning: #ffa500; /* Approx from design sample */\n  --toast-neutral: #e9eaec; /* Gray/200 */\n  --toast-radius: 8px;\n  --toast-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.03),\n    0px 3px 14px 2px rgba(0, 0, 0, 0.07),\n    0px 5px 5px -3px rgba(0, 0, 0, 0.06);\n}\n\n/* ========================================\n   Toast Base Styles\n   ======================================== */\n.tl-toast {\n  display: flex;\n  align-items: stretch;\n  gap: 12px;\n  position: relative;\n  background: var(--toast-bg);\n  color: var(--toast-text);\n  border-radius: var(--toast-radius);\n  box-shadow: var(--toast-shadow);\n  padding: 8px 12px 8px 22px;\n  min-width: 280px;\n  max-width: 420px;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  line-height: 1.15;\n  overflow: hidden;\n  /* Base state */\n  opacity: 1;\n  transform: translateX(0);\n}\n\n/* ========================================\n   Toast Internal Elements\n   ======================================== */\n.tl-toast__bar {\n  position: absolute;\n  left: 6px;\n  top: 6px;\n  bottom: 6px;\n  width: 4px;\n  border-radius: 2px;\n}\n\n.tl-toast__content {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.tl-toast__message {\n  color: var(--toast-text);\n  flex: 1;\n  min-width: 0;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.tl-toast__muted {\n  color: var(--toast-muted);\n  font-size: 12px;\n}\n\n.tl-toast__spacer {\n  flex: 0;\n}\n\n.tl-toast__action {\n  border: none;\n  background: transparent;\n  color: #0860e6; /* Blue/400 */\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  padding: 4px 6px;\n  border-radius: 6px;\n  transition: background-color 150ms ease;\n}\n\n.tl-toast__action:hover {\n  background-color: rgba(8, 96, 230, 0.1);\n}\n\n.tl-toast__close {\n  border: none;\n  background: transparent;\n  color: var(--toast-text);\n  opacity: 0.9;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  padding: 4px;\n  font-size: 18px;\n  line-height: 1;\n  transition: opacity 150ms ease, background-color 150ms ease;\n}\n\n.tl-toast__close:hover {\n  opacity: 1;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* ========================================\n   Variant Color Bars\n   ======================================== */\n.tl-toast--neutral .tl-toast__bar {\n  background: var(--toast-neutral);\n}\n\n.tl-toast--info .tl-toast__bar {\n  background: var(--toast-info);\n}\n\n.tl-toast--success .tl-toast__bar {\n  background: var(--toast-success);\n}\n\n.tl-toast--warning .tl-toast__bar {\n  background: var(--toast-warning);\n}\n\n.tl-toast--error .tl-toast__bar {\n  background: var(--toast-error);\n}\n\n/* ========================================\n   Animations - Smooth Slide from Left\n   ======================================== */\n@keyframes toast-slide-in-left {\n  0% {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes toast-slide-in-right {\n  0% {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes toast-slide-out-left {\n  0% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n}\n\n/* Enter phase - fade in */\n.tl-toast.enter {\n  animation: toast-fade-in 220ms ease forwards;\n}\n\n/* Idle phase - maintain visible state */\n.tl-toast.idle {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n/* Exit phase - fade out */\n.tl-toast.exit {\n  animation: toast-fade-out 180ms ease forwards;\n}\n\n@keyframes toast-fade-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes toast-fade-out {\n  from { opacity: 1; }\n  to   { opacity: 0; }\n}\n\n/* ========================================\n   Toast Container\n   ======================================== */\n.tl-toast-container {\n  position: fixed;\n  top: 16px;\n  right: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  z-index: 9999;\n  pointer-events: none;\n}\n\n.tl-toast-container > * {\n  pointer-events: auto;\n}\n\n/* ════════════════════════════════════════════════════\n   PILL TOAST — POS cart screen only\n   Subtle inline pill that sits between the island\n   and the right-side icon cluster in the navbar.\n   ════════════════════════════════════════════════════ */\n.tl-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 32px;\n  padding: 0 12px 0 10px;\n  border-radius: 999px;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 12.5px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* subtle lift */\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  cursor: default;\n}\n\n/* ── Variant backgrounds & text ── */\n.tl-pill--success {\n  background: rgba(5, 150, 105, 0.1);\n  border: 1px solid rgba(5, 150, 105, 0.28);\n  color: #065f46;\n}\n.tl-pill--error {\n  background: rgba(220, 38, 38, 0.09);\n  border: 1px solid rgba(220, 38, 38, 0.28);\n  color: #991b1b;\n}\n.tl-pill--warning {\n  background: rgba(217, 119, 6, 0.09);\n  border: 1px solid rgba(217, 119, 6, 0.28);\n  color: #92400e;\n}\n.tl-pill--info {\n  background: rgba(42, 113, 255, 0.08);\n  border: 1px solid rgba(42, 113, 255, 0.25);\n  color: #1d4ed8;\n}\n.tl-pill--neutral {\n  background: rgba(100, 116, 139, 0.08);\n  border: 1px solid rgba(100, 116, 139, 0.22);\n  color: #475569;\n}\n\n/* ── Inner elements ── */\n.tl-pill__message {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tl-pill__close {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 15px;\n  line-height: 1;\n  padding: 0 0 0 4px;\n  opacity: 0.55;\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  transition: opacity 0.15s;\n  flex-shrink: 0;\n}\n.tl-pill__close:hover { opacity: 1; }\n\n/* ── Animations ── */\n@keyframes pill-enter {\n  from { opacity: 0; transform: translateY(-6px) scale(0.95); }\n  to   { opacity: 1; transform: translateY(0)   scale(1);    }\n}\n@keyframes pill-exit {\n  from { opacity: 1; transform: translateY(0)   scale(1);    }\n  to   { opacity: 0; transform: translateY(-6px) scale(0.95); }\n}\n\n.tl-pill.enter { animation: pill-enter 0.22s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }\n.tl-pill.idle  { opacity: 1; transform: translateY(0) scale(1); }\n.tl-pill.exit  { animation: pill-exit  0.18s ease forwards; }\n\n/* ── Dark mode ── */\n.dark .tl-pill--success {\n  background: rgba(5, 150, 105, 0.15);\n  border-color: rgba(5, 150, 105, 0.32);\n  color: #6ee7b7;\n}\n.dark .tl-pill--error {\n  background: rgba(220, 38, 38, 0.14);\n  border-color: rgba(220, 38, 38, 0.32);\n  color: #fca5a5;\n}\n.dark .tl-pill--warning {\n  background: rgba(217, 119, 6, 0.14);\n  border-color: rgba(217, 119, 6, 0.32);\n  color: #fcd34d;\n}\n.dark .tl-pill--info {\n  background: rgba(42, 113, 255, 0.14);\n  border-color: rgba(42, 113, 255, 0.3);\n  color: #93c5fd;\n}\n.dark .tl-pill--neutral {\n  background: rgba(100, 116, 139, 0.14);\n  border-color: rgba(100, 116, 139, 0.28);\n  color: #94a3b8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
